import React, { Component, useEffect } from "react";
import { useQuery } from "react-query";
import i18next from "i18next";

import "@learningblocks/shared-components/lib/i18n";
import plotFunctions from "./data/plot-calculations";
import { Scrolly } from "@learningblocks/interactives/scrollable-components";

const fetchSceneData = async () => {
  const sceneDataPath = "scene.json";
  const response = await fetch(sceneDataPath);

  const contentType = response.headers.get("content-type");
  if (!contentType || !contentType.includes("application/json")) {
    const projectPath = window.location.pathname
        .split("/")
        .filter(Boolean)
        .pop();
    throw new Error(`Scene data not found. The scrollable project ${projectPath} might not exist. Please check the URL or contact support.`);
  }
  return response.json();
};

export class ProductionErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ProductionErrorBoundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="query-error">
          <div
            style={{
              color: "white",
              fontSize: "20px",
              padding: "20px",
              textAlign: "center",
            }}
          >
            <p
              style={{ color: "white", marginBottom: "15px", fontSize: "24px" }}
            >
              <strong>An error occurred.</strong>
            </p>
            <p style={{ color: "white", marginBottom: "15px" }}>
              Check console for details.
            </p>
            <p style={{ color: "white", marginBottom: "15px" }}>
              Error: {this.state.error?.message}
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default function ProductionScrollable({ lang }) {
  useEffect(() => {
    i18next.changeLanguage(lang);
  }, [lang]);

  const compressedLang = () => {
    const req = new XMLHttpRequest();
    const animationLocation =
      window.location.origin +
      window.location.pathname +
      `locales/${lang}/animation.lottie`;

    try {
      req.open("HEAD", animationLocation, false);
      req.send();
      return req.status === 200 ? lang : "en";
    } catch {
      return "en";
    }
  };

  const { data: sceneData } = useQuery("scene-data", fetchSceneData, {
    suspense: true,
    retry: false,
  });

  return (
    <Scrolly
      animationData=""
      sceneData={sceneData}
      plotFunctions={plotFunctions}
      animLng={compressedLang()}
    />
  );
}
